<template>
  <section id="store-selection-nav" class="mb-2">
    <div class="container" v-if="isCouponSpecials">
      <div class="row default-coupons-header">
        <div class="default-banner-container jumbotron d-flex justify-content-center align-items-center flex-wrap">
          <div class="banner-title">
            <h1 class="text-center text-uppercase w-100 font-weight-bold">Coupons & Specials</h1>
            <h3 class="text-center w-100">Save Money with In-Store Coupons & Online Coupon Codes</h3>
          </div>
        </div>
      </div>
    </div>
    <PromotionBanner :promotion="promotion" v-else></PromotionBanner>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h3 class="text-center mt-4 mb-2">See What Coupons and Offers Are Available at Your Local Tint World<sup>&reg;</sup> Store</h3>
          <p class="text-center">Select <strong>My Store</strong> to choose your preferred Tint World<sup>&reg;</sup> store. Once you have set your store, the location specific offers will display below!</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-2 mb-4">
        <div class="col-md-12">
          <StoreNav :userLocationView="true"></StoreNav>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import StoreNav from "@/components/StoreNav";
import PromotionBanner from "@/components/promotion/PromotionBanner";

export default {
  name: "PromoNoUserStore",
  //@TODO - We should also check logic for situations where MyStore is set but no promotion is assigned (though we can probably capture that via server and populate default coupons?)
  components: {
    StoreNav,
    PromotionBanner
  },
  props: {
    isCouponSpecials: Boolean,
    promotion: Object
  },
  computed: {
    stored_promotion(){
      return this.$store.state.promotion;
    }
  }
}
</script>
<style>
.default-coupons-header {
  padding-bottom:28%;
  position:relative;
}
.default-banner-container {
  background-image: url(https://res.cloudinary.com/tint-world/image/upload/w_auto,f_auto,q_auto:good/tw-uploads-2/images/img-coupons-specials/hero_b7f326e5.jpg);
  color: #fff;
  height:100%;
  width:100%;
  background-size:cover;
  position:absolute;
}
</style>
